// Enterprise Crews v2 API Repository
import http from "@/http/aisea/axios_v2";
const resource = "/enterprises/crews";
import qs from "qs";

export default {
  /**
   * (V2) 法人船員一覧取得API
   *
   * @param {Object} params - 以下の条件で絞り込みが可能です。
   * details:
   *   - CREW_AVAILABLE_ROLE
   *   - CREW_LICENSE
   *   - CREW_RESPONSIBILITY
   */
  fetch(payload) {
    return http.get(`${resource}`, {
      params: payload,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },

  /**
   * (V2) 法人船員詳細取得API
   *
   * @param {String} id - 船員ID
   * @param {Object} params - 以下の条件で絞り込みが可能です。
   * details:
   *   - CREW_AVAILABLE_ROLE
   *   - AFFILIATED_COMPANY
   * @returns {Object} 船員詳細
   */
  fetchById(id, payload) {
    return http.get(`${resource}/${id}`, {
      params: payload,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
};
